import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-user-profile',
  templateUrl: './company-user-profile.component.html',
  styleUrls: ['./company-user-profile.component.css']
})
export class CompanyUserProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
